import { render, staticRenderFns } from "./formattedCreatedAt.vue?vue&type=template&id=4924a50c"
import script from "./formattedCreatedAt.vue?vue&type=script&lang=js"
export * from "./formattedCreatedAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports